import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import withPillNavigationDecorator from '../../shared/withPillNavigation.decorator';
import AgGrid from '../../shared/agGrid/agGrid.component';

import { BOOK_TYPES, TOTAL_ROW_VALUE } from './constants';
import TaxExpenseDraftBanner from '../viewTaxExpensePage/draftBanner.component';
import { UnmountOnChange } from '../../shared/unmountOnChange.component';

const getPillDefs = ({ useHistorical, selectedBookTypes }) => [
  ...!useHistorical ? [{ label: 'US Summary', type: BOOK_TYPES.US_SUMMARY }] : [],
  { label: 'US Federal', type: BOOK_TYPES.US_FED },
  { label: 'US State', type: BOOK_TYPES.US_STATE },
  { label: 'GAAP Non-US', type: BOOK_TYPES.TED_NON_US_GAAP },
  { label: 'STAT Non-US', type: BOOK_TYPES.TED_NON_US_STAT },
].filter(({ type }) => !Array.isArray(selectedBookTypes) || selectedBookTypes.includes(type));

class TaxExpenseGridView extends PureComponent {
  static propTypes = {
    reportData: PropTypes.shape({
      name: PropTypes.string,
      orientation: PropTypes.string,
      rows: PropTypes.arrayOf(PropTypes.shape({
        rowType: PropTypes.string,
        description: PropTypes.string,
        columns: PropTypes.arrayOf(PropTypes.shape({
          value: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number,
          ]),
        })),
      })),
      columnCount: PropTypes.number,
      rawSource: PropTypes.arrayOf(PropTypes.shape({
      })),
    }),
    columnDefs: PropTypes.arrayOf(PropTypes.shape({
    })),
    taxExpenseLoading: PropTypes.bool,
    groupTypeColumn: PropTypes.string.isRequired,
    rebuildReactTooltip: PropTypes.func,
    shouldShowDraftBanner: PropTypes.bool,
  };

  moveTotalRowToTheTop = rowNodes => {
    const { groupTypeColumn } = this.props;

    const move = (toIndex, fromIndex) => {
      rowNodes.splice(toIndex, 0, rowNodes.splice(fromIndex, 1)[0]);
    };

    rowNodes.forEach((row, index) => {
      if (row.data[groupTypeColumn] === TOTAL_ROW_VALUE) {
        move(0, index);
      }
    });
  };

  render() {
    const { reportData, taxExpenseLoading, columnDefs, rebuildReactTooltip, shouldShowDraftBanner } = this.props;

    return (
      <div className="ag-grid-full-page-with-secondary-menu">
        {!taxExpenseLoading && shouldShowDraftBanner ? <TaxExpenseDraftBanner /> : null}
        <UnmountOnChange dependencies={[columnDefs]}>
          <AgGrid
            columnDefs={columnDefs}
            onRowDataUpdated={rebuildReactTooltip}
            onModelUpdated={rebuildReactTooltip}
            onFirstDataRendered={rebuildReactTooltip}
            onViewportChanged={rebuildReactTooltip}
            rowData={reportData && reportData.rawSource}
            componentToRenderOnSearchBar={<div>{reportData.name}</div>}
            headerHeight={60}
            allowRowShadowing
            withSearchBar
            isGridLoading={taxExpenseLoading}
            postSort={this.moveTotalRowToTheTop}
          />
        </UnmountOnChange>
      </div>
    );
  }
}

export default withPillNavigationDecorator(
  getPillDefs,
  {
    propTypes: {
      bookType: PropTypes.string.isRequired,
      selectedBookTypes: PropTypes.arrayOf(PropTypes.string),
      selectBookType: PropTypes.func.isRequired,
    },
    getActivePill: props => props.bookType,
    onPillChangeEventPropKey: 'selectBookType',
  }
)(TaxExpenseGridView);
